/*
  we should be informed when no name or version is passed because
  tracker-babbel WILL FAIL SILENTLY in such cases. it will execute,
  but will not actually fire the event.

  we should also be informed when no locale or learn_language_alpha3 is passed because
  its part of the spec for the events we are using.
*/
import { RUNTIME_ENVIRONMENT } from 'src/dataLayer/env'

import { reportValidationError } from '../rollbar'

// Check that version is a numeric value
const validateVersion = (version) => version / 1 === version

const handleInvalidEventProps = (eventProperties) => {
  if (RUNTIME_ENVIRONMENT !== 'production') {
    console.error(`
      Attempted to emit an event to Babbel Event Stream, but was either missing a required or contained an invalid prop:
        ${JSON.stringify(eventProperties)}
    `)
  }

  const { name, ...payload } = eventProperties

  reportValidationError('validationError', name, payload)
}

const hasValidEventProperties = ({ locale, name, version }) =>
  Boolean(name && validateVersion(version) && locale)

const validateEventProps = (eventProperties) => {
  if (!hasValidEventProperties(eventProperties)) {
    handleInvalidEventProps(eventProperties)
  }
}

export { handleInvalidEventProps, validateEventProps }
